import { IconInfoCircle } from "@tabler/icons-react";
import { useState } from "react";
import { IconAction, Loader } from "@/components/ui";
import { toastErrorApi } from "@/lib/toast";
import { ConsultaContratoModal } from "@/features/seleccionar-contrato-anualizado/components/ConsultaContratoModal";
import { contratoAnualizadoApi, type ConsultaContrato } from "@/features/seleccionar-contrato-anualizado/services/contrato-anualizado.api";
import { ConsultaOrdenModal } from "@/features/seleccionar-orden-compra/components/ConsultaOrdenModal";
import { ordenCompraApi, type ConsultaOrden } from "@/features/seleccionar-orden-compra/services/orden-compra.api";

/**
 * Botón (solo ícono) de la columna CA/OC de «Mis solicitudes» · abre la consulta de solo
 * lectura del Contrato Anualizado o de la Orden de Compra (los mismos modales del wizard).
 */
export function BotonInfoCaOc({ tipo, clave }: { tipo: string | null; clave: string }) {
  const esContrato = tipo === "ContratoAnualizado";
  const [cargando, setCargando] = useState(false);
  const [contrato, setContrato] = useState<ConsultaContrato | null>(null);
  const [orden, setOrden] = useState<ConsultaOrden | null>(null);

  const abrir = async () => {
    setCargando(true);
    try {
      if (esContrato) setContrato(await contratoAnualizadoApi.consultar(clave));
      else setOrden(await ordenCompraApi.consultar(clave));
    } catch (e) {
      toastErrorApi(e);
    } finally {
      setCargando(false);
    }
  };

  return (
    <>
      <IconAction
        label={esContrato ? "Información del Contrato Anualizado" : "Información de la Orden de Compra"}
        size="sm"
        tone="info"
        onClick={abrir}
        disabled={cargando}
      >
        {cargando ? <Loader size="xs" /> : <IconInfoCircle size={16} />}
      </IconAction>
      {esContrato ? (
        <ConsultaContratoModal contrato={contrato} onClose={() => setContrato(null)} />
      ) : (
        <ConsultaOrdenModal orden={orden} onClose={() => setOrden(null)} />
      )}
    </>
  );
}
